import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StoreService {

  readonly local: Storage;

  constructor() {
    this.local = window.localStorage;
  }

  /* istanbul ignore next: "details why you chose to ignore this line for code coverage" */
  public set(key: string, value: any): void {
    if (value) {
      this.local.setItem(key, JSON.stringify(value));
      return;
    }
    this.local.setItem(key, value);
  }

  /* istanbul ignore next: "details why you chose to ignore this line for code coverage" */
  public get(key: string): any {
    if (key) {
      return JSON.parse(this.local.getItem(key));
    }
    return this.local.getItem(key);
  }

  /* istanbul ignore next: "details why you chose to ignore this line for code coverage" */
  public remove(key: string): void {
    this.local.removeItem(key);
  }

  /* istanbul ignore next: "details why you chose to ignore this line for code coverage" */
  public size(): number {
    return this.local.length;
  }

  /* istanbul ignore next: "details why you chose to ignore this line for code coverage" */
  public clear(): void {
    this.local.clear();
  }


}
